import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { PurchaseSection } from './components/PurchaseSection';
import { Objections } from './components/Objections';
import { Support } from './components/Support';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel PageView tracking
    const pixelId = '1252242806993118';
    // Inject fbq script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Inject noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Problems data-id="element-2" />
      <Modules data-id="element-3" />
      <Testimonials data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Comparison data-id="element-6" />
      <PurchaseSection data-id="element-7" />
      <Objections data-id="element-8" />
      <Support data-id="element-9" />
      <PurchasePopup data-id="element-10" />
    </div>;
}